import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <div className="flex flex-1 lg:pt-0 pt-16">
        <Sidebar />
        <main className="flex-1 bg-gray-50 lg:ml-0 ml-0">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

